import React from 'react'

import { Divider } from '@/components/ui/divider'
import { Anchor } from '@/components/ui/anchor'

export type DocsSectionProps = {
  anchorId?: string
  dividerLine?: boolean
  pathname?: string
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>

export const DocsSection: React.FC<DocsSectionProps> = (props) => {
  const { children, anchorId, dividerLine = true, pathname, ...other } = props

  return (
    <section {...other}>
      {dividerLine ? <Divider /> : ''}
      <Anchor id={anchorId} pathname={pathname} />
      {children}
    </section>
  )
}
